(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initReveal(scope) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      scope.querySelectorAll('.pp-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    scope.querySelectorAll('.pp-reveal').forEach(function (el) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          entries[0].target.classList.add('is-visible');
          io.disconnect();
        }
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      io.observe(el);
    });
  }

  document.querySelectorAll('.pp-reviews').forEach(initReveal);

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.pp-reviews');
    if (s) initReveal(s);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-pirmapinas"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  requestAnimationFrame(function () {
    document.querySelectorAll('[data-hero-pirmapinas]').forEach(function (el) {
      el.classList.add('is-loaded');
    });
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klaviyo-email-signup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('[data-email-signup]');
  if (!sections.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  sections.forEach(function (el) {
    if (reduce || typeof IntersectionObserver === 'undefined') {
      el.classList.add('is-in-view');
      return;
    }
    el.classList.add('email--js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    io.observe(el);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-pirmapinas"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manifesto"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initReveal(scope) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      scope.querySelectorAll('.pp-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    scope.querySelectorAll('.pp-reveal').forEach(function (el) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          entries[0].target.classList.add('is-visible');
          io.disconnect();
        }
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      io.observe(el);
    });
  }

  document.querySelectorAll('.pp-manifesto').forEach(initReveal);

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.pp-manifesto');
    if (s) initReveal(s);
  });
}());

  } catch(e) { console.error(e); }
})();
})();
